import { cn } from '@/new/lib/utils';

export function CountBadge({ count, className }: { count: number; className?: string }) {
  if (count) {
    return (
      <span
        className={cn(
          'absolute -top-2 -right-2 z-10 flex size-4.5 items-center justify-center rounded-full border border-teal-400 bg-teal-50 text-[10px] font-medium text-teal-600 tabular-nums',
          className,
        )}
      >
        {count}
      </span>
    );
  }
}
